export class FailedToDeleteSttError extends Error {
  constructor() {
    super(
      'An error occurred while trying to regenerate this recording. Please try again later or contact support@fortherecord.com for support',
    )
    Object.setPrototypeOf(this, FailedToDeleteSttError.prototype)
  }
}
